import React from 'react';

const FinancialCard = ({ title, value }) => (
    <div className="clinic-dashboard-financial-item">
        <div className="clinic-dashboard-financial-item-label">{title}</div>
        <div className="clinic-dashboard-financial-item-value">{value}</div>
    </div>
);

export default FinancialCard;
